export default __webpack_public_path__ + "static/media/Check.13071486.svg";